import React, { Component } from "react";
import moment from "moment";
import Bridge from "../../../utils/Bridge";
import { Spin } from "antd";
import { Chart, registerables } from "chart.js";
import { Line } from "react-chartjs-2";

Chart.register(...registerables);

export default class MaximumPhonationTime extends Component {
  constructor(props) {
    super(props);
    this.state = {
      records: [],
      loading: false,
    };
  }

  componentDidMount() {
    this.getInClinicSessionList();
  }

  getInClinicSessionList = () => {
    this.setState({ loading: true });
    let params = "?eals_id=" + this.props.eals_id;
    Bridge.personal_data_viewer.le_study
      .get_le_study_in_clinic_session_list(params)
      .then((response) => {
        console.log("response", response);
        if (response.status == "1") {
          this.setState({ records: response.data, loading: false }, () => {
            this.getMptChartData();
          });
        } else {
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };

  getMptChartData = () => {
    const displayData = this.state.records.length > 0 ? this.state.records : [];

    // Extract data for graph - dates and longest MPT values (max of mpt1, mpt2, mpt3)
    const chartData = displayData
      .map((item) => {
        // Find the longest duration from mpt1, mpt2, mpt3
        const mptValues = [
          item.mpt1 !== null && item.mpt1 !== undefined ? item.mpt1 : null,
          item.mpt2 !== null && item.mpt2 !== undefined ? item.mpt2 : null,
          item.mpt3 !== null && item.mpt3 !== undefined ? item.mpt3 : null,
        ].filter((val) => val !== null);

        const longestMpt = mptValues.length > 0 ? Math.max(...mptValues) : null;

        return {
          date:
            item.sessionDate ||
            (item.entry_date
              ? moment(item.entry_date).format("MM/DD/YY")
              : null),
          value: longestMpt,
        };
      })
      .filter(
        (item) =>
          item.date !== null && item.value !== null && item.value !== undefined
      )
      .sort(
        (a, b) =>
          moment(a.date, "MM/DD/YY").unix() - moment(b.date, "MM/DD/YY").unix()
      );

    // Calculate min and max values for y-axis
    const values = chartData.map((item) => item.value);
    // Default axis range: 0-30 sec when no data
    let yMin = 0;
    let yMax = 30;

    // Adjust axis based on data if available
    if (values.length > 0) {
      const dataMin = Math.min(...values);
      const dataMax = Math.max(...values);
      // Add padding: 10% below min (but not less than 0) and 10% above max
      yMin = Math.max(0, dataMin - (dataMax - dataMin) * 0.1);
      yMax = dataMax + (dataMax - dataMin) * 0.1;
      // Round up to nearest 5 for cleaner axis
      yMax = Math.ceil(yMax / 5) * 5;
      // Ensure minimum range of 0-30 if calculated max is less than 30
      if (yMax < 30) {
        yMax = 30;
      }
    }

    return {
      labels: chartData.map((item) => item.date),
      datasets: [
        {
          label: "MPT, Longest duration (sec)",
          data: chartData.map((item) => item.value),
          borderColor: "#007bff",
          backgroundColor: "#007bff",
          borderWidth: 2,
          pointRadius: 8,
          pointBackgroundColor: "#007bff",
          pointBorderColor: "#000",
          pointBorderWidth: 1.5,
          pointHoverRadius: 10,
          pointHoverBackgroundColor: "#007bff",
          pointHoverBorderColor: "#000",
          tension: 0,
          spanGaps: false,
        },
      ],
      yAxisMin: yMin,
      yAxisMax: yMax,
    };
  };

  render() {
    const formData = this.props.language || {};
    const mptChartData = this.getMptChartData();

    // Safe access to nested language properties with fallbacks
    const mptLongestDurationLabel =
      formData?.page?.personalDataViewer?.maximumPhonationTime?.charts
        ?.mptLongestDuration || "MPT, Longest duration";
    // Get sessionDate from charts.sessionDate (from english.json structure)
    const sessionDateLabel =
      formData?.page?.personalDataViewer?.maximumPhonationTime?.charts
        ?.sessionDate || "Session Date";
    const notAvailableText = formData?.page?.notAvailable || "Not Available";

    return (
      <div className="als_frs_sessions">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 px-0">
              <Spin spinning={this.state.loading}>
                <div
                  className="respiratory-tab-content respiratory-chart-container"
                  style={{ minHeight: "500px" }}
                >
                  <Line
                    key="mpt-chart"
                    data={mptChartData}
                    options={{
                      responsive: true,
                      maintainAspectRatio: false,
                      layout: {
                        padding: {
                          left: 15,
                          right: 15,
                          top: 15,
                          bottom: 15,
                        },
                      },
                      plugins: {
                        legend: {
                          display: false,
                        },
                        title: {
                          display: true,
                          font: {
                            size: 16,
                            weight: "bold",
                          },
                          color: "#000",
                          padding: {
                            top: 10,
                            bottom: 20,
                          },
                        },
                      },
                      scales: {
                        y: {
                          beginAtZero: true,
                          min: mptChartData.yAxisMin,
                          max: mptChartData.yAxisMax,
                          title: {
                            display: true,
                            text: mptLongestDurationLabel + " (sec)",
                            font: {
                              size: 12,
                              weight: "bold",
                            },
                            color: "#000",
                          },
                          ticks: {
                            color: "#000",
                            stepSize: 5,
                          },
                          grid: {
                            color: "rgba(0, 0, 0, 0.1)",
                          },
                          offset: true,
                          afterFit: function (scale) {
                            scale.paddingTop = 20;
                            scale.paddingBottom = 20;
                            scale.paddingRight = 10;
                          },
                        },
                        x: {
                          title: {
                            display: true,
                            text: sessionDateLabel,
                            font: {
                              size: 12,
                              weight: "bold",
                            },
                            color: "#000",
                          },
                          ticks: {
                            color: "#000",
                          },
                          grid: {
                            display: false,
                          },
                          offset: true,
                          afterFit: function (scale) {
                            scale.paddingLeft = 20;
                            scale.paddingRight = 20;
                          },
                        },
                      },
                    }}
                  />
                </div>
                {/* <table>
                  <tr>
                    <th>
                      {
                        formData.page.personalDataViewer.maximumPhonationTime
                          .sessionDate
                      }
                    </th>
                    <th>
                      {
                        formData.page.personalDataViewer.maximumPhonationTime
                          .trial1
                      }
                    </th>
                    <th>
                      {
                        formData.page.personalDataViewer.maximumPhonationTime
                          .trial2
                      }
                    </th>
                    <th>
                      {
                        formData.page.personalDataViewer.maximumPhonationTime
                          .trial3
                      }
                    </th>
                  </tr>
                  {this.state.records && this.state.records.length > 0 &&
                    this.state.records.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>
                            {item.sessionDate ||
                              (item.entry_date
                                ? moment(item.entry_date).format("MM/DD/YY")
                                : "---")}
                          </td>
                          <td>
                            {item.mpt1 !== null && item.mpt1 !== undefined
                              ? `${item.mpt1} ${formData.page.personalDataViewer.maximumPhonationTime.totalDurationSeconds}`
                              : "---"}
                          </td>
                          <td>
                            {item.mpt2 !== null && item.mpt2 !== undefined
                              ? `${item.mpt2} ${formData.page.personalDataViewer.maximumPhonationTime.totalDurationSeconds}`
                              : "---"}
                          </td>
                          <td>
                            {item.mpt3 !== null && item.mpt3 !== undefined
                              ? `${item.mpt3} ${formData.page.personalDataViewer.maximumPhonationTime.totalDurationSeconds}`
                              : "---"}
                          </td>
                        </tr>
                      );
                    })}
                  {this.state.records && this.state.records.length === 0 && (
                    <tr>
                      <td colSpan={4}>
                        {" "}
                        {notAvailableText}
                      </td>
                    </tr>
                  )}
                </table> */}
              </Spin>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
